// extracted by mini-css-extract-plugin
export var buttonContainer = "_7c-1";
export var fontSizeSelect = "_7c-3";
export var formatSelect = "_7c-2";
export var formats = "_7c-4";
export var hidden = "_7c-5";
export var icon = "_7c-6";
export var select = "_7c-0";